// This file was automatically generated from appchart.dialog.refaxLetter.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.refaxLetter');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.refaxLetter.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="refax-letter-content" class="el8DialogContainer overlayContainer"><div class="el8FieldSection"><label class="el8label el8FieldLong">Subject:</label><p class="el8FieldLongLabelPadding el8Wrap subject-field">', (opt_data.isReferralLetter) ? 'Referral' : (opt_data.subject) ? soy.$$escapeHtml(opt_data.subject) : '(no subject)', '</p></div><div class="el8FieldSection"><label class="el8label el8FieldLong">Written:</label><p class="el8FieldLongLabelPadding el8Wrap written-field">', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), '</p></div><div class="el8FieldSection"><label class="el8label el8FieldLong">To:</label><p class="el8FieldLongLabelPadding el8Wrap to-field">', soy.$$escapeHtml(opt_data.displayTo), '</p></div><div class="fax-attachments-section"><label class="el8label el8CheckMark el8CheckMarkHighlight"><input name="includeAttachments" type="checkbox" /><span class="ml5 el8NormalText">Also fax copies of the attachments</span></label></div></div>');
  if (!opt_sb) return output.toString();
};
